// Modulul de consimțământ cookie — chei, versiune, utilitare pentru stocare și GA.
export const CONSENT_KEY = "selik_cookie_consent";
export const CONSENT_VERSION = 1;
export const CONSENT_DAYS = 180;
export const GA_ID = "G-9J655207BR";

// Listează cookie-urile cunoscute ale Google Analytics și le șterge,
// pe cât este tehnic posibil, pentru toate variantele de domeniu.
export function clearGaCookies() {
  const names = [];
  // _ga (inclusiv _ga_<MeasurementId>), _gid, _gat*
  if (document.cookie) {
    document.cookie.split(";").forEach((raw) => {
      const name = raw.split("=")[0].trim();
      if (
        name === "_ga" ||
        name.startsWith("_ga_") ||
        name === "_gid" ||
        name.startsWith("_gat") ||
        name.startsWith("_gac_")
      ) {
        names.push(name);
      }
    });
  }
  names.push("_ga", "_gid", "_gat", `_ga_${GA_ID}`, `_gat_${GA_ID}`);

  const hosts = [window.location.hostname];
  // curăță și fără subdomeniu, când este cazul
  const bare = window.location.hostname.split(".").slice(-2).join(".");
  if (bare !== window.location.hostname) hosts.push(bare);

  const paths = ["/", window.location.pathname];
  const unique = [...new Set(names)];
  const hostsUnique = [...new Set(hosts)];

  const expire = "Thu, 01 Jan 1970 00:00:01 GMT";
  unique.forEach((name) => {
    paths.forEach((path) => {
      hostsUnique.forEach((host) => {
        document.cookie = `${name}=; expires=${expire}; path=${path}; domain=${host}`;
      });
      document.cookie = `${name}=; expires=${expire}; path=${path}`;
    });
  });
}
